// extracted by mini-css-extract-plugin
export default {"category":"Category_category__1Gt1o","name":"Category_name__eV34r","imageDiv":"Category_imageDiv__IcE7J","image":"Category_image__guIEc","button":"Category_button__40cCq"};